export const getNotificationSettings = (state) => state.settings.notification
export const getTaxClasses = (state) => state.settings.taxClasses
